import { LitElement, html } from 'lit';
import { style } from './sign-in-card.style.js';

class RefiSignInCard extends LitElement {
  static get styles() {
    return [style];
  }

  render() {
    return html`
      <div class="sign-in-card" role="button" tabindex="0">
        <slot class="sign-in-card__image" name="icon" alt=""></slot>
        <div class="sign-in-card__content">
          <fs-heading class="sign-in-card__header">
            <slot name="header"></slot>
          </fs-heading>
          <fs-body-text class="sign-in-card__body">
            <slot name="content"></slot>
          </fs-body-text>
        </div>
      </div>
    `;
  }
}

customElements.define('refi-sign-in-card', RefiSignInCard);
